import React, { forwardRef } from 'react';
import LookupMui from 'features/common/MaterialBasedComponents/Lookup';
import { useDispatch } from 'react-redux';
import { fetchDocumentsLookup } from 'features/viewing/redux/fetchDocumentsLookup';

export default forwardRef((props, ref) => {
  const dispatch = useDispatch();
  return (
    <LookupMui
      {...props}
      PopperProps={{ style: { zIndex: 100007 } }}
      loadOptions={(inputValue) => dispatch(fetchDocumentsLookup(inputValue))}
      minInputLength={2}
      valueKey="id"
      valueKey0="crossRefPrompt"
      labelKey="name"
      subLabelKeys={['externalId', 'discoveryId']}
      placeholder="Search document or type link"
      variant="outlined"
      noOptionsText="No documents"
      customInput
    />
  );
});
